module.exports = require("@hala-systems/react-timezone-provider");